import ReviewsStateStatistics from '@app/model/review/state/ReviewsStateStatistics';
import StateStatisticsForProvider from '@app/model/review/state/StateStatisticsForProvider';
import StateStatisticsForCategory from '@app/model/review/state/StateStatisticsForCategory';

export default class CompetitorReviewsState {
	competitorId: number;
	hotelId: number;
	hotelName: string;
	isCompetitor: boolean;
	isMainHotel: boolean;
	statistics: ReviewsStateStatistics;
	stateStatisticsForProviders: StateStatisticsForProvider[] = [];
	stateStatisticsForCategories: StateStatisticsForCategory[] = [];

	constructor(data: CompetitorReviewsState) {
		Object.assign(this, data);
		this.statistics = new ReviewsStateStatistics(data.statistics);
		this.stateStatisticsForProviders = data.stateStatisticsForProviders
			? data.stateStatisticsForProviders.map(item => new StateStatisticsForProvider(item))
			: [];
		this.stateStatisticsForCategories = data.stateStatisticsForCategories
			? data.stateStatisticsForCategories.map(item => new StateStatisticsForCategory(item))
			: [];
	}

	get stateStatisticsForRootCategories() {
		return this.stateStatisticsForCategories.filter(s => s.category.isRoot && s.category.children.length > 0);
	}

}
